module.exports = __webpack_public_path__ + "img/wholy_zzzzzzzzzz2.e166f93.png";